import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  settingsList = [
    {name:"Account Settings", description:'Details about your personal information', 
      icon:'person', route:'/app/settings'
    },
    {name:"Security", description:'Change your password and Pin', icon:'vpn_key', route:'password'},
    // {name:"Notification Settings", description:'Customise your notifications', icon:'notifications', route:'notifications'},
  ]

  
  checkViewport: Observable<boolean> = this.breakpointObserver.observe('(max-width: 650px)')
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  display: boolean = false;

  constructor(private breakpointObserver: BreakpointObserver) { }

  ngOnInit(): void {
  }

}
